import mutations from './discounts.mutations'
import actions from './discounts.actions'
import getters from './discounts.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
